import React from 'react';

export const uangDiragukanReplenishmentConfig = [
  {
    path: '/cash-replenishment-uang-diragukan',
    component: React.lazy(() => import('./listing/listing')),
  },
  {
    path: '/cash-replenishment-uang-diragukan/isi-surat-klarifikasi',
    component: React.lazy(() => import('./suratKlarifikasi/suratKlarifikasi')),
  },
  {
    path: '/cash-replenishment-uang-diragukan/overview-surat-klarifikasi',
    component: React.lazy(() =>
      import('./overViewKlarifikasi/overViewKlarifikasi'),
    ),
  },
  {
    path: '/cash-replenishment-uang-diragukan/isi-surat-tanggapan',
    component: React.lazy(() => import('./suratTanggapan/suratTanggapan')),
  },
  {
    path: '/cash-replenishment-uang-diragukan/overview-surat-tanggapan',
    component: React.lazy(() =>
      import('./overViewTanggapan/overViewTanggapan'),
    ),
  },
  {
    path: '/cash-replenishment-uang-diragukan/detail',
    component: React.lazy(() => import('./detail/detail')),
  },
];
